import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/client/Home";
import Cart from "./pages/client/Cart";
import Checkout from "./pages/client/Checkout";
import CheckoutSuccess from "./pages/client/CheckoutSuccess";
import Categories from "./pages/client/Categories";
import ProductDetail from "./pages/client/ProductDetail";
import Login from "./pages/dashboard/auth/Login";
import Boutiques from "./pages/client/Boutiques";
import BecomeSeller from "./pages/client/BecomeSeller";
import Account from "./pages/client/Account";
import KilLayout from "./layouts/kil-dashboard/AppLayout";
import KilDashboardHome from "./pages/dashboard/Home";
import KilDashboardOrderList from "./pages/dashboard/orders/OrderList";
import OrderDetail from "./pages/dashboard/orders/OrderDetail";
import Invoice from "./pages/dashboard/orders/Invoice";
import KilDashboardProductList from "./pages/dashboard/products/ProductList";
import AddProduct from "./pages/dashboard/products/AddProduct";
import KilDashboardCategorieList from "./pages/dashboard/products/categories/CategorieList";
import CategoryDetail from "./pages/dashboard/products/categories/CategoryDetail";
import KilDashboardSettings from "./pages/dashboard/settings/Settings";
function AppRouter() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/checkout/success" element={<CheckoutSuccess />} />
        <Route path="/categories" element={<Categories />} />
        <Route path="/product/:id" element={<ProductDetail />} />
        <Route path="/vendor/login" element={<Login />} />
        <Route path="/boutiques" element={<Boutiques />} />
        <Route path="/become-seller" element={<BecomeSeller />} />
        <Route path="/account" element={<Account />} />

        {/* Dashboard */}
        <Route path="/dashboard" element={<KilLayout />}>
          <Route index element={<KilDashboardHome />} />
          <Route path="products" element={<KilDashboardProductList />} />
          <Route path="products/add" element={<AddProduct />} />
          <Route path="orders" element={<KilDashboardOrderList />} />
         <Route path="orders/:orderId" element={<OrderDetail />} />
         <Route path="orders/:orderId/invoice" element={<Invoice />} />
                         <Route path="categories" element={<KilDashboardCategorieList />} />
               <Route path="categories/:categoryId" element={<CategoryDetail />} />
          <Route path="settings" element={<KilDashboardSettings />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default AppRouter; 